import styles from 'css/src/components/app/recorder/VoiceoverPreview.module.scss';

import React from 'react';

import LottieAsset from 'js/src/components/common/ui/LottieAsset';

const RIPPLE_LOTTIE_PATH =
    'https://lottie.host/079e1290-1448-4f14-b43d-4af23ceafb6d/uvBH3CgYRA.json';

type VoiceoverPreviewProps = {
    recordingUrl?: string;
};

/**
 * Center-stage visual for voiceover recording. A `VoiceoverRecorder` produces an
 * audio-only stream (no video track), so there is nothing to show in a `<video>`
 * preview — we render an animated "ripple" instead to indicate the mic is live,
 * with an optional audio player for reviewing the finished recording.
 */
const VoiceoverPreview: React.FC<VoiceoverPreviewProps> = ({ recordingUrl }) => (
    <div
        className={`${styles['voiceover-preview']} d-flex justify-content-center align-items-center`}
    >
        <LottieAsset path={RIPPLE_LOTTIE_PATH} loop autoplay play />
        {recordingUrl && (
            <audio
                className={styles['playback']}
                src={recordingUrl}
                controls
                autoPlay
                controlsList="nodownload nofullscreen"
                onContextMenu={(e) => e.preventDefault()}
            />
        )}
    </div>
);

export default React.memo(VoiceoverPreview);
